import React from 'react';
import { Link } from 'react-router-dom';
import AppHamburgerMenu from '../layout/AppHamburgerMenu';
import CubeSVG from '../cube-svgrepo-com.svg';

/** Home cube plus hamburger for order / shipment / bundle-work detail navbars. */
function DetailNavbarLeft(): React.ReactElement {
  return (
    <div className="order-detail-navbar-left">
      <Link to="/" className="order-detail-navbar-home" aria-label="Home">
        <img src={CubeSVG} alt="" />
      </Link>
      <span className="order-detail-navbar-hamburger">
        <AppHamburgerMenu menuClassName="order-detail-navbar-menu" />
      </span>
    </div>
  );
}

export default DetailNavbarLeft;
